import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface ObjetivosPlanPayload {
  id_plan: number;
  objetivos: string;
  estado?: number;
}

export interface ObjetivosPlan {
  id?: number;
  id_plan: number;
  objetivos: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface ObjetivosPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ObjetivosPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/objetivos_plan`;

  constructor(private http: HttpClient) {}

  // ================================================
  // CONSULTAS
  // ================================================

  // Listar todos los objetivos (todos los planes)
  getAll(): Observable<ObjetivosPlan[]> {
    return this.http.get<ObjetivosPlan[]>(this.apiUrl, { withCredentials: true });
  }

  // Listar objetivos filtrados por plan
  getByIdPlan(id_plan: number): Observable<ObjetivosPlan[]> {
    return this.http.get<ObjetivosPlan[]>(`${this.apiUrl}/plan/${id_plan}`, { withCredentials: true });
  }

  // Obtener un objetivo por su propio ID
  getById(id: number): Observable<ObjetivosPlan> {
    return this.http.get<ObjetivosPlan>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // ================================================
  // ESCRITURA
  // ================================================

  create(payload: ObjetivosPlanPayload): Observable<ObjetivosPlanResponse> {
    return this.http.post<ObjetivosPlanResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<ObjetivosPlanPayload>): Observable<ObjetivosPlanResponse> {
    return this.http.put<ObjetivosPlanResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // ================================================
  // CAMBIO DE ESTADO
  // ================================================

  inactivar(id: number): Observable<ObjetivosPlanResponse> {
    return this.http.put<ObjetivosPlanResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  activar(id: number): Observable<ObjetivosPlanResponse> {
    return this.http.put<ObjetivosPlanResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}